/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import * as React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import styled from "styled-components";

import { EditPONumbersIconPropTypes } from "../admin/billing/lib/types";
import { StyledEditButton } from "../admin/billing/lib/styles";

const editPencil = require("../svg/editPencil.svg");
const addPlus = require("../svg/addPlus.svg");

const StyledPencilImage = styled.img`
  position: absolute;
  height: auto;
  width: auto;
`;

const StyledPlusImage = styled.img`
  position: absolute;
  height: auto;
  width: auto;
`;

const EditPONumbersIcon = ({
  openModal,
  type,
}: EditPONumbersIconPropTypes): React.ReactElement => {
  return (
    <StyledEditButton
      onClick={openModal}
      size="small"
      testId={`po-numbers-${type}-icon`}
      variant="icon"
    >
      {type === "add" ? (
        <StyledPlusImage
          alt={i18n.translate(
            "admin_pages.settings.billing.po_numbers.modal_title"
          )}
          src={addPlus}
        />
      ) : (
        <StyledPencilImage
          alt={i18n.translate(
            "admin_pages.settings.billing.po_numbers.modal_title"
          )}
          src={editPencil}
        />
      )}
    </StyledEditButton>
  );
};

export default EditPONumbersIcon;
